import { Reducers } from '@sda/enums/store';
import { SDKFactory } from './helpers/sdk.factory';
import { SDK } from './helpers/sdk';
import type { EnvironmentVariables } from '@sda/interfaces/setting';
import type { EmailTemplate } from '@sda/interfaces/setting/emailtemplate';
import type { ExchangeRate } from '@sda/interfaces/setting/exchangerate';
import type { Configuration } from '@sda/interfaces/setting/homepage';
import type { IPAddress } from '@sda/interfaces/setting/ipaddress';

/**
 * SDK Class to interact with Firestore Settings.
 */
export class Settings extends SDK<never> {
  /**
   * Returns a FirestoreBaseClass instance for the EmailTemplates collection
   */
  EmailTemplates(): SDK<EmailTemplate> {
    return SDKFactory<EmailTemplate>(this.fsh.clientData, this.fsh.Schema.EmailTemplates, { reducerName: Reducers.EMAIL_TEMPLATES });
  }

  /**
   * Returns a FirestoreBaseClass instance for the ExchangeRates collection
   */
  ExchangeRates(): SDK<ExchangeRate> {
    return SDKFactory<ExchangeRate>(this.fsh.clientData, this.fsh.Schema.ExchangeRates);
  }

  Functions(): SDK<EnvironmentVariables> {
    return SDKFactory<EnvironmentVariables>(this.fsh.clientData, this.fsh.Schema.FunctionsSettings);
  }

  Hosting(): SDK<EnvironmentVariables> {
    return SDKFactory<EnvironmentVariables>(this.fsh.clientData, this.fsh.Schema.HostingSettings);
  }

  /**
   * Returns a FirestoreBaseClass instance for the IPAddresses collection
   *
   * @return {FirestoreBaseClass}
   */
  IPAddresses(): SDK<IPAddress> {
    return SDKFactory<IPAddress>(this.fsh.clientData, this.fsh.Schema.IPAddresses);
  }

  /**
   * Returns a FirestoreBaseClass instance for the HomePage collection
   * @return {HomePage}
   */
  HomePage(): SDK<Configuration> {
    return SDKFactory<Configuration>(this.fsh.clientData, this.fsh.Schema.HomePage);
  }
}
